import { render, staticRenderFns } from "./Splash-Screen.vue?vue&type=template&id=5449c55b&scoped=true&"
import script from "./Splash-Screen.vue?vue&type=script&lang=ts&"
export * from "./Splash-Screen.vue?vue&type=script&lang=ts&"
import style0 from "./Splash-Screen.vue?vue&type=style&index=0&id=5449c55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449c55b",
  null
  
)

export default component.exports